
namespace GeniuzPOS.ReportMasterData {
    import fld = Report_1201_DiscRow.Fields;

    @Serenity.Decorators.registerClass()
    export class Report_1201_DiscGrid extends Serenity.EntityGrid<Report_1201_DiscRow, any> {
        protected getColumnsKey() { return Report_1201_Disc2Columns.columnsKey; }
        protected getDialogType() { return Report_1201_DiscDialog; }
        protected getIdProperty() { return Report_1201_DiscRow.idProperty; }
        protected getInsertPermission() { return Report_1201_DiscRow.insertPermission; }
        protected getLocalTextPrefix() { return Report_1201_DiscRow.localTextPrefix; }
        protected getService() { return Report_1201_DiscService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }

        protected usePager() {
            return false;
        }

        protected createToolbarExtensions() {
            super.createToolbarExtensions();

            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });

            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["UpdateBy"]);
            // groupingMixin.plugin.setDroppedGroups(["PluCode"]);


        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        }

        protected markupReady() {
            super.markupReady();

            // expanding all level 0 (Country) and level 1 (City) groups initially
            this.view.expandAllGroups(0);
            // this.view.expandAllGroups(1);
            // this.view.expandAllGroups(2);

        }

        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: Report_1201_DiscService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            return buttons
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            Q.first(filters, x => x.field == fld.CreateDate).init = w => {

                (w as Serenity.DateEditor).valueAsDate = new Date(Date.now());

                let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
                endDate.valueAsDate = new Date(Date.now());
            };

           


            return filters;
        }
        protected createSlickGrid() {
            var grid = super.createSlickGrid();

        

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [

                    
                    // new Slick.Aggregators.Sum('AllItemDiscount'),
                    // new Slick.Aggregators.Sum('NetSales'),
                    new Slick.Aggregators.Sum('Discamt'),
                    new Slick.Aggregators.Sum('ChargeAmt'),
                    // new Slick.Aggregators.Sum('CurrencyAmt'),

                ]

            });

            return grid;
        }

    }
}